import { SubHeaderModule } from './../sub-header/sub-header.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { welcomeNotesComponent } from './welcomeNotes.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { TranslateModule } from '@ngx-translate/core';
import { PanelModule } from 'primeng-lts/panel';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { ToolbarModule } from 'primeng-lts/toolbar';

@NgModule({
  declarations: [welcomeNotesComponent],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    PanelModule,
    PdfViewerModule,
    ToolbarModule,
    TranslateModule,
    SubHeaderModule,
    ScrollPanelModule
  ]
})
export class WelcomeNotesModule { }
